import { DAY_NAMES, HOURS, MINUTES } from '../../constants/openingHours';
const TimeSelect = ({ value, onChange }) => {
  const [hour = '00', minute = '00'] = String(value || '00:00').split(':');
  return (
    <div className="time-picker" dir="ltr">
      <select
        value={hour.padStart(2, '0')}
        onChange={(e) => onChange(`${e.target.value}:${minute.padStart(2, '0')}`)}
      >
        {HOURS.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
      <span>:</span>
      <select
        value={minute.padStart(2, '0')}
        onChange={(e) => onChange(`${hour.padStart(2, '0')}:${e.target.value}`)}
      >
        {MINUTES.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );
};
const OpeningHoursEditor = ({
  days,
  addRange,
  removeRange,
  updateRange,
  duplicateDay,
  duplicateTargets,
  setDuplicateTargets,
  setOpen247,
  isOpen247,
}) => {
  return (
    <section className="opening-editor editor-section">
      <header className="subsection-header">
        <div>
          <h3>שעות פעילות</h3>
          <span>אפשר להוסיף כמה טווחים לכל יום ולשכפל יום ליום יעד</span>
        </div>
        <label className="switch-row">
          <input
            type="checkbox"
            checked={isOpen247}
            onChange={(e) => setOpen247(e.target.checked)}
          />
          <span>פתוח 24/7</span>
        </label>
      </header>
      <div className="opening-table">
        <div className="opening-head">
          <span>יום</span>
          <span>טווחים</span>
          <span>פעולות</span>
        </div>
        {days.map((day) => (
          <div className="opening-row" key={day.day}>
            <strong>{day.name}</strong>
            <div className="ranges-list">
              {day.ranges.length === 0 && <span className="closed-label">סגור</span>}
              {day.ranges.map((range, rangeIndex) => (
                <div className="range-row" key={`${day.day}-${rangeIndex}`}>
                  <label className="checkbox compact-checkbox">
                    <input
                      type="checkbox"
                      checked={range.isOpen24Hours}
                      onChange={(e) =>
                        updateRange(day.day, rangeIndex, 'isOpen24Hours', e.target.checked)
                      }
                    />{' '}
                    24 שעות
                  </label>
                  {!range.isOpen24Hours && (
                    <>
                      <TimeSelect
                        value={range.open}
                        onChange={(value) => updateRange(day.day, rangeIndex, 'open', value)}
                      />
                      <span>עד</span>
                      <TimeSelect
                        value={range.close}
                        onChange={(value) => updateRange(day.day, rangeIndex, 'close', value)}
                      />
                    </>
                  )}
                  <button
                    type="button"
                    className="mini danger"
                    onClick={() => removeRange(day.day, rangeIndex)}
                  >
                    מחיקה
                  </button>
                </div>
              ))}
            </div>
            <div className="day-actions">
              <button type="button" className="mini" onClick={() => addRange(day.day)}>
                +
              </button>
              <select
                value={duplicateTargets[day.day]}
                onChange={(e) =>
                  setDuplicateTargets((current) =>
                    current.map((value, index) =>
                      index === day.day ? Number(e.target.value) : value,
                    ),
                  )
                }
              >
                {DAY_NAMES.map((name, index) => (
                  <option key={name} value={index} disabled={index === day.day}>
                    {name}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="mini secondary"
                onClick={() => duplicateDay(day.day, duplicateTargets[day.day])}
              >
                שכפל
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
export default OpeningHoursEditor;
